/**
 * @file: cube数据库
 * @author: xiaolong.huang@dmall.com
 */

import Utils from '../utils/util';
import { getCubeType } from './cubeType';

let cubeMap: Map<CubeId, CubeNode> = new Map();
let shelvesMap: CubeMap = {};
let cubeTypeDB: Map<CubeType, Set<CubeId>> = new Map();
let cubeProxy: Map<CubeId, any> = new Map();

function __clear__(): void {
    cubeMap.clear();
    cubeTypeDB.clear();
    cubeProxy.clear();
    shelvesMap = {};
}

function __getShelvesMap__(): CubeMap {
    return shelvesMap;
}

function __getAllCubeIds__(): Array<CubeId> {
    return Array.from(cubeMap.keys());
}

function __get__(cubeId: CubeId): CubeNode|null {
    return cubeMap.get(cubeId) || null;
}

function __getCubeReader__(cubeId: CubeId): CubeNode|null {
    return cubeProxy.get(cubeId) || null;
}

function __getByType__(type: CubeType): CubeId[] {
    if (!cubeTypeDB.has(type)) {
        return [];
    }

    return Array.from(cubeTypeDB.get(type));
}

function __set__(cubeId: CubeId, cube: CubeNode): void {
    let type: CubeType = getCubeType(cube);

    if (!cubeTypeDB.has(type)) {
        cubeTypeDB.set(type, new Set());
    }
    cubeTypeDB.get(type).add(cubeId);
    cubeMap.set(cubeId, cube);
    cubeProxy.set(cubeId, __createCubeProxy__(cube));
    shelvesMap[cubeId] = cube;
}

function __has__(cubeId: CubeId): boolean {
    return cubeMap.has(cubeId);
}

function __delete__(cubeId: CubeId): void {
    let cube: CubeNode = __get__(cubeId);
    let type: CubeType = getCubeType(cube);

    if (cubeTypeDB.has(type)) {
        cubeTypeDB.get(type).delete(cubeId);
    }
    cubeMap.delete(cubeId);
    cubeProxy.delete(cubeId);
    delete shelvesMap[cubeId];
}

function __createCubeProxy__(cube: CubeNode): any {
    return Utils.createDeepReader(cube);
}

export {
    __clear__,
    __getShelvesMap__,
    __getAllCubeIds__,
    __get__,
    __getByType__,
    __set__,
    __has__,
    __delete__,
    __getCubeReader__
};
